
    import { Component, Vue, Prop } from 'vue-property-decorator';
    import Tooltip from "@/components/survey/Tooltip.vue";
    
    import { stepInfoType } from "@/types/Application";
    import PageBase from "@/components/steps/PageBase.vue";   
    import GetHelpForPdf from "./helpPages/GetHelpForPDF.vue";

    import FormList from "./components/FormList.vue";
    import RequiredDocument from "./components/RequiredDocument.vue";
    import ReminderNotes from "./components/ReminderNotes.vue";
    
    import { namespace } from "vuex-class";   
    import "@/store/modules/application";
    const applicationState = namespace("Application");

    import "@/store/modules/common";
    import { documentTypesJsonInfoType, locationsInfoType, requiredDocumentsInfoType } from '@/types/Common';
    const commonState = namespace("Common");


    @Component({
        components:{
            PageBase,
            GetHelpForPdf,
            Tooltip,
            FormList,
            RequiredDocument,
            ReminderNotes
        }
    })
    
    export default class ResubmitAttachments extends Vue {
        
        @Prop({required: true})
        step!: stepInfoType;

        @commonState.State
        public userLocation!: string;

        @commonState.State
        public locationsInfo!: locationsInfoType[];

        @applicationState.State
        public id!: string;

        @applicationState.State
        public types!: string[];

        @applicationState.State
        public steps!: stepInfoType[];

        @applicationState.State
        public rejectedFormsList!: any[];

        @applicationState.State
        public applicationLocation!: string;

        @applicationState.State
        public rejectedPathway!: boolean;
        
        @applicationState.State
        public rejectedFileNumber!: string;

        @applicationState.State
        public currentStep!: number;

        @commonState.State
        public documentTypesJson!: documentTypesJsonInfoType[];

        @applicationState.State
        public supportingDocuments!: any;

        @applicationState.State
        public requiredDocuments!: requiredDocumentsInfoType;

        @applicationState.Action
        public UpdateSupportingDocuments!: (newSupportingDocuments) => void

        @applicationState.Action
        public UpdateGotoPrevStepPage!: () => void

        @applicationState.Action
        public UpdateGotoNextStepPage!: () => void

        @applicationState.Action
        public UpdatePageProgress!: (newPageProgress) => void        

        error = "";

        applicantLocation = {} as locationsInfoType;        
        submissionInProgress = false;
        
        supportingFile = null;
        selectedDocumentTypeState = true;
        selectedSupportingDocumentState = true;
        fileType = "";
        fileTypes: documentTypesJsonInfoType[] = [];
        ppmSchedule1FileType = {description: 'Schedule 1 completed by a director', type: 'Merge With Form15'};
        scheduleOneText = "Completed Schedule 1 (to be completed by a director under the Child, Family and Community Service Act)<ul class='mt-3' style='line-height: 1.5; list-style-type:circle;'><li>When you upload your completed Schedule 1, you will need to select from the drop list of document types – Schedule 1, completed by the Director from the top of the drop list. Once uploaded, the Schedule 1 will be attached to your Application About a Priority Parenting Matter when you click the Proceed to Submit button.</li></ul>";
        supportingDocumentFields = [
            { key: 'fileName', label: 'File Name',tdClass:'align-middle'},
            { key: 'fileType', label: 'File Type',tdClass:'align-middle'},
            { key: 'edit', thClass: 'd-none',tdClass:'align-middle'},
            { key: 'preview', thClass: 'd-none'}
        ];
       
        showTypeOfDocuments = false;
        submitEnable = true;
        currentPage=0;

        mounted(){

            this.submitEnable =  true;
            const progress = 50;
            
            this.currentPage = Number(this.steps[this.currentStep].currentPage)
            this.UpdatePageProgress({ currentStep: this.currentStep, currentPage: this.currentPage, progress: progress });
       
            let location = this.applicationLocation
            if(!this.applicationLocation) location = this.userLocation;

            this.applicantLocation = this.locationsInfo.filter(loc => {if (loc.name == location) return true})[0]              
           
            this.fileTypes = this.documentTypesJson;
           
            const dropArea = document.getElementById('drop-area');
            dropArea.addEventListener('drop', this.handleFileDrop, false);
            dropArea.addEventListener('dragenter', this.dragPreventDefaults, false);
            dropArea.addEventListener('dragleave', this.dragPreventDefaults, false);
            dropArea.addEventListener('dragover', this.dragPreventDefaults, false);            
        }

        public dragPreventDefaults (e) {
            e.preventDefault()
            e.stopPropagation()
        }

        public handleFileDrop(e) {
            e.preventDefault()
            e.stopPropagation()
            const dt = e.dataTransfer
            const files = dt.files

            if (files && files[0]) 
            {
                this.supportingFile = files;
                this.handlePpmSchedule1();
                this.showTypeOfDocuments= true;
            }
        } 

        public uploadClicked(){
            const el = document.getElementById("inputfile");
            if(el) el.click();
        }

        public handleSelectedFile(event){

            event.preventDefault();
            event.stopPropagation();
            
            if (event.target.files && event.target.files[0]) 
            {
                this.supportingFile = event.target.files;
                this.handlePpmSchedule1();
                this.showTypeOfDocuments= true;
            }
        }
        
        public onPrev() {
            Vue.prototype.$UpdateGotoPrevStepPage()
        }

        public onNext() {
            Vue.prototype.$UpdateGotoNextStepPage()
        }        

        public onSubmit() {                     
            
            if (this.types.includes("Priority Parenting Matter") && this.requiredDocuments?.priorityParenting?.required?.includes(this.scheduleOneText)){

                const index = this.supportingDocuments.findIndex(doc => doc.documentType == this.ppmSchedule1FileType.type);

                if (index == -1){
                    this.error = 'You should include: Completed Schedule 1 (to be completed by a director under the Child, Family and Community Service Act)'
                } else {
                    this.eFile();
                }

            } else {
                this.eFile();
            }
                       
        }

        public eFile() {
            
            this.error = "";
            const bodyFormData = new FormData();
            const docType = []
            const lastFileTypes = this.supportingDocuments[this.supportingDocuments.length-1]?this.supportingDocuments[this.supportingDocuments.length-1].typeIndex:0
          
            let fileIndex = 0;
            for(const filetype of lastFileTypes){
            
                const tempSupportingDocs = this.supportingDocuments.filter(doc=>{return(doc.documentType==filetype)})
            
                if(tempSupportingDocs.length>0){
                    const filesIndices = [];
                    const filesRotation = [];
                    for(const supportingDoc of tempSupportingDocs){
                        bodyFormData.append('files',supportingDoc['file']);
                        filesIndices.push(fileIndex)
                        filesRotation.push(supportingDoc['imageRotation'])
                        fileIndex++;
                    }
                    docType.push({type: tempSupportingDocs[0]['documentType'], files: filesIndices, rotations:filesRotation})
                }
            }
            
            docType.push({type:"FPO"})
            
            const docTypeJson = JSON.stringify(docType);
            bodyFormData.append('documents', docTypeJson);          

            const url = "/efiling/"+this.id+"/submit/?standalone=True" 
            const header = {
                responseType: "json",
                headers: {
                    "Content-Type": "multipart/form-data",
                    Accept: "application/json"                  
                }
            }
            
            this.submissionInProgress = true;
            
            this.$http.post(url, bodyFormData, header)
            .then(res => {

                if(res?.data?.message=="success")
                {
                    this.generateUrl(res.data.redirectUrl)                   
                }
            }, err => {
                this.error = err.response.data.message;
                this.submissionInProgress = false;
            });           
        }
        
        public generateUrl(eFilingUrl) {            
            // redirect user to the generated url
            location.replace(eFilingUrl);        
        }      

        public removeDocument(index) {
            this.supportingDocuments.splice(index, 1);
        }
        
        public addDocument() {
            this.selectedSupportingDocumentState = this.supportingFile? true:false;
            this.selectedDocumentTypeState = this.fileType.length>0? true: false;

            if (this.supportingFile && this.fileType.length>0) {

                this.showTypeOfDocuments = false;

                const supportingdocuments = this.supportingDocuments 
                const typeIndex =  this.supportingDocuments[this.supportingDocuments.length-1]?this.supportingDocuments[this.supportingDocuments.length-1].typeIndex:[]
                if(!typeIndex.includes(this.fileType))
                    typeIndex.push(this.fileType)
                
                for(const supportingfile of this.supportingFile){
               
                    const newFile = {
                        "fileName": supportingfile.name,
                        "file": supportingfile,
                        "documentType": this.fileType,
                        "image": URL.createObjectURL(supportingfile),
                        "imageRotation": 0,
                        "typeIndex":typeIndex
                    }
                    supportingdocuments.push(newFile);
                }

                this.UpdateSupportingDocuments(supportingdocuments);
                this.supportingFile = null;
                this.fileType = "";
                Vue.nextTick(()=>{
                    const el = document.getElementById('drop-area');
                    if(el) el.scrollIntoView();
                })
            }
        }

        public handlePpmSchedule1(){
            
            const index = this.fileTypes.findIndex(fileType => fileType.type == this.ppmSchedule1FileType.type);

            if (this.requiredDocuments?.priorityParenting?.required?.includes(this.scheduleOneText) && index == -1){

                this.fileTypes.unshift(this.ppmSchedule1FileType);

            } else if(!this.requiredDocuments?.priorityParenting?.required?.includes(this.scheduleOneText) && index != -1) {                
                                
                this.fileTypes.splice(index, 1);
                           
            }
        } 

        get isSubmissionReady(){ 
            
            if (this.rejectedFormsList.length > 0){

                if (this.supportingDocuments.length == 0){
                    return false;
                } else {

                    const supportingDocumentTypes = this.supportingDocuments.map(doc => doc.documentType)

                    for (const doc of this.rejectedFormsList){
                        
                        if (!supportingDocumentTypes.includes(doc.type)) return false;
                    }
                    return true;
                }

            } else {
                return true;
            }
            
        }

    }
